import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/electrical';
export function Testimonials() {
  return <section className="bg-white px-4 py-4 sm:py-6" data-id="element-192" data-mp="3kqw36hd9ewej">
      <div className="mx-auto max-w-4xl" data-id="element-193" data-mp="3fz5pc1f45qid">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-194" data-mp="3fy316196e265">
          WHAT ELECTRICAL PROFESSIONALS ARE SAYING
        </h2>

        <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-195" data-mp="36ypokzpr8xh7">
          {testimonials.map((testimonial, i) => <li key={testimonial.name} className={`flex flex-col rounded-lg border border-navy/10 bg-tech p-2.5 shadow-sm ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-196" data-mp="31zd3okig20h9" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-197" data-mp="2s3jjqg2eb4pg">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-volt text-volt" aria-hidden="true" data-id="element-198" data-mp="q9tyfiabiuig" data-mpi={star} />)}
              </div>
              <p className="mt-1 text-[13px] font-medium leading-snug text-carbon/85" data-id="element-199" data-mp="m62pk5tiw9ud">
                “{testimonial.quote}”
              </p>
              <p className="mt-auto pt-1.5 font-head text-[13px] font-extrabold text-navy" data-id="element-200" data-mp="79v83d9i1mis">
                {testimonial.name}
              </p>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-carbon/60" data-id="element-201" data-mp="zw65kf1t77bd">
                {testimonial.role}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}